import { query } from 'src/utils/request';
// 交易明细查询
// https://yapi.cai-inc.com/project/3075/interface/api/738034
export async function querytradeDetailList(data) {
  return query('/zlb/api/pay/jinkong/trade/detail/page', {
    method: 'POST',
    data,
  });
}
// 获取当前登录的账户
//  https://yapi.cai-inc.com/project/3075/interface/api/738074
export async function getPersonAccountUserid(data) {
  return query('/zlb/api/pay/jinkong/person/account/get-by-userid', {
    method: 'GET',
    data,
  });
}

// 同步交易明细
//  https://yapi.cai-inc.com/project/3075/interface/api/738026
export async function syncTradeDetail(data) {
  return query('/zlb/api/pay/jinkong/trade/detail/sync', {
    method: 'POST',
    data,
  });
}

// 根据用户id获取账户
//  https://yapi.cai-inc.com/project/3075/interface/api/738082
export async function getOperatorListById(data) {
  return query('/zlb/api/pay/jinkong/person/account/list-by-operatorid', {
    method: 'POST',
    data,
  });
}

// 更新消费明细
// https://yapi.cai-inc.com/project/3075/interface/api/749370
export async function updateTradeDetail(data) {
  return query('/zlb/api/pay/jinkong/trade/detail/udpate', {
    method: 'POST',
    data,
  });
}
